import { useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { SegmentedButtons } from 'react-native-paper'
import { ClockInForm } from '@/ui/time-entry/ClockInForm'
import { StartBreakCard } from '@/ui/time-entry/StartBreakCard'

type Tab = 'clockIn' | 'break'

interface ClockInBreakTabsProps {
    orgSlug: string
    isLocked?: boolean
}

const TAB_BUTTONS = [
    { value: 'clockIn', label: 'Clock In', icon: 'clock-start', showSelectedCheck: false },
    { value: 'break', label: 'Break', icon: 'coffee-outline', showSelectedCheck: false },
]

export function ClockInBreakTabs({ orgSlug, isLocked }: ClockInBreakTabsProps) {
    const [tab, setTab] = useState<Tab>('clockIn')

    // When locked, the clock-in form renders its own locked notice; tabs would be
    // pointless since neither action is allowed.
    if (isLocked) {
        return <ClockInForm orgSlug={orgSlug} isLocked />
    }

    return (
        <View>
            <View style={styles.tabs}>
                <SegmentedButtons
                    value={tab}
                    onValueChange={value => setTab(value as Tab)}
                    buttons={TAB_BUTTONS}
                />
            </View>
            {tab === 'clockIn' ? (
                <ClockInForm orgSlug={orgSlug} />
            ) : (
                <StartBreakCard orgSlug={orgSlug} />
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    tabs: {
        marginBottom: 16,
    },
})
